import React from "react";
import AusenciaService from "../../services/AusenciaService";
import CrudList from "../../components/forms/custom/CrudList";
import Util from "../../utils/Util";

export default class ListaAusencia extends CrudList {

    constructor(props) {
        super(props);

        this.state.crud = {
            service: AusenciaService,
            labels: {
                title: 'Lista de Ausência(s)',
                btnNewRegister: 'Ausência',
            },
            keyItem: 'idAusencia',
            urlForm: '/CadAusencia',
            itensFilter: ["idAusencia", "nome"],
            searchFormSubmit: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderHeader() {
        return (
            <>
                <th className="col-md-2 text-center d-none d-md-table-cell"> Código </th>
                <th className="col-md-4"> Nome </th>
                <th className="col-md-3"> Período </th>
                <th className="col-md-3 text-center"> Status </th>
            </>
        );
    }

    getVigencia(cdVigencia) {
        switch (cdVigencia) {
            case "V":
                return <span className="badge bg-success">VIGENTE</span>;
            case "F":
                return <span className="badge bg-primary">FUTURO</span>;
            case "P":
                return <span className="badge bg-danger">PASSADO</span>;
            default:
                return <span className="badge bg-primary"></span>;
        }
    }

    getRenderItem(item) {
        return (
            <>
                <td className="text-center d-none d-md-table-cell">{item.idAusencia}</td>
                <td>{item.nome}</td>
                <td>{Util.date2Br(item.dtInicio)} {item.hrInicio} à {Util.date2Br(item.dtFim)} {item.hrFim}</td>
                <td className="text-center">
                    {this.getVigencia(item.cdVigencia)}
                </td>
            </>);
    }

    render() {
        return super.render();
    }
}